import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "homesite.recent-lookups";
const MAX_LOOKUPS = 5;

export interface UseRecentLookups {
	recent: string[];
	remember: (id: string) => void;
	forget: (id: string) => void;
	clear: () => void;
}

export function useRecentLookups(): UseRecentLookups {
	const [recent, setRecent] = useState<string[]>(() => readStorage());

	useEffect(() => {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
		} catch {
			// ignore quota / disabled storage
		}
	}, [recent]);

	const remember = useCallback((id: string) => {
		setRecent((prev) => {
			const filtered = prev.filter((p) => p !== id);
			return [id, ...filtered].slice(0, MAX_LOOKUPS);
		});
	}, []);

	const forget = useCallback((id: string) => {
		setRecent((prev) => prev.filter((p) => p !== id));
	}, []);

	const clear = useCallback(() => setRecent([]), []);

	return { recent, remember, forget, clear };
}

function readStorage(): string[] {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return [];
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed)
			? parsed.filter((x): x is string => typeof x === "string")
			: [];
	} catch {
		return [];
	}
}
